import namespace from './namespace';

export default {
	[namespace.state.HIERARCHY_STATE]: {},
	[namespace.state.AVAILABLE_JIRA_VALUES]: [],
	[namespace.state.IS_EPIC_TYPE_MAPPED]: false,
	[namespace.state.IS_EPIC_NAME_MAPPED]: false,
	[namespace.state.IS_NEXT_GEN]: false,
	[namespace.state.WAITING_FOR_RESPONSE]:false,
	[namespace.state.SELECTED_JIRA_LINK]:''
};


// WEBPACK FOOTER //
// ./src/store/modules/hierarchy/state.js